import { render, staticRenderFns } from "./EventCard.vue?vue&type=template&id=27f3fe92&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"
import style0 from "./EventCard.vue?vue&type=style&index=0&id=27f3fe92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.28_css-loader@6.11.0_webpack@5.105.1__lodash@4_6fd9dbbebaebfbe303bf4cf98ec4c0cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f3fe92",
  null
  
)

export default component.exports